<div
  class="input-container"
  [class.error]="hasError"
  [class.with-clear-icon]="value && value.length > 0 && !disabled"
  [style.width]="width"
>
  <ng-container *ngIf="startIcon">
    <mat-icon class="start-icon" aria-hidden="true">{{ startIcon }}</mat-icon>
  </ng-container>
  <input
    id="input"
    type="text"
    class="input"
    [disabled]="disabled"
    [ngClass]="{ 'with-start-icon': startIcon, 'without-start-icon': !startIcon }"
    [value]="value"
    (focus)="onFocus()"
    (blur)="onBlur()"
    (input)="onInput($event)"
    [attr.aria-invalid]="hasError"
  />
  <label
    for="input"
    class="label"
    [ngClass]="{
      'with-start-icon': startIcon,
      'without-start-icon': !startIcon,
      'floating': isFloating || value
    }"
  >
    {{ placeholder }}
  </label>
  <mat-icon
    *ngIf="value && value.length > 0 && !disabled"
    class="clear-icon"
    (click)="clearInput()"
    aria-label="Clear input"
    aria-hidden="false"
  >
    close
  </mat-icon>
</div>
<div *ngIf="helperText" [class.error-message]="hasError" class="helper-text">
  {{ helperText }}
</div>
